var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.629741 0H9.44612C9.79393 0 10.0759 0.281948 10.0759 0.629741V12.6851C10.0759 12.8589 9.93486 13 9.76099 13C9.70186 13 9.64386 12.9832 9.59373 12.9518L5.03793 10.0956L0.482124 12.9518C0.33479 13.0442 0.14047 12.9997 0.0480932 12.8523C0.0166691 12.8022 0 12.7443 0 12.6851V0.629741C0 0.281948 0.281948 0 0.629741 0ZM8.81638 1.25948H1.25948V10.9779L5.03793 8.609L8.81638 10.9779V1.25948Z",
    fill: "#7E8392"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tag-icon.7ef3865bd01bf9e391ea223b20c84239.svg";
export { ForwardRef as ReactComponent };